'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var date;
function getCurrentDate() {
    if (date) {
        return date;
    }
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    date = dd + "." + mm + "." + yyyy;
    return date;
}
var replacments = {
    '{{DATE}}': getCurrentDate,
};
var Regex = {
    STRONG: /__([^\s_])__(?!_)|\*\*([^\s*])\*\*(?!\*)|__([^\s][\s\S]*?[^\s])__(?!_)|\*\*([^\s][\s\S]*?[^\s])\*\*(?!\*)/g,
    ITALIC: /_([^\s_])_(?!_)|_([^\s_<][\s\S]*?[^\s_])_(?!_|[^\s,punctuation])|_([^\s_<][\s\S]*?[^\s])_(?!_|[^\s,punctuation])|\*([^\s*<\[])\*(?!\*)|^\*([^\s<"][\s\S]*?[^\s\[\*])\*(?![\]`punctuation])|\*([^\s*"<\[][\s\S]*[^\s])\*(?!\*)/g,
    HYPERLINK: /(\[[^\]]+\])(\([^)]+\))/,
    STRIKETHROUGH: /(~~)(.*?)(~~)/,
};
var rules = [
    {
        regex: Regex.STRONG,
        replaceFn: function (match) { return "<strong>" + match.substring(2, match.length - 2) + "</strong>"; },
    },
    {
        regex: Regex.ITALIC,
        replaceFn: function (match) { return "<em>" + match.substring(1, match.length - 1) + "</em>"; },
    },
    {
        regex: Regex.STRIKETHROUGH,
        replaceFn: function (match) { return "<s>" + match.substring(2, match.length - 2) + "</s>"; },
    },
    {
        regex: Regex.HYPERLINK,
        replaceFn: function (str) {
            var matches = str.match(Regex.HYPERLINK);
            if ((matches === null || matches === void 0 ? void 0 : matches[1]) && (matches === null || matches === void 0 ? void 0 : matches[2])) {
                var hyperlinkText = matches[1].substring(1, matches[1].length - 1);
                var hyperlinkUrl = matches[2].substring(1, matches[2].length - 1);
                return "<a href=\"" + hyperlinkUrl + "\">" + hyperlinkText + "</a>";
            }
            return '';
        },
    },
];
function template(text) {
    var testWithReplacments = text.replace(/\{\{[A-Z]+\}\}/gm, function (match) {
        return replacments[match] ? replacments[match]() : '';
    });
    return rules.reduce(function (carry, rule) { return carry.replace(rule.regex, rule.replaceFn); }, testWithReplacments);
}

exports.Regex = Regex;
exports.default = template;
//# sourceMappingURL=index.js.map
